"use strict";
/*
 * Created on 04 29 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var index_1 = require("../../../core/utils/index");

var SelloutImpactReportDetailFilterDTO_1 = require("../model/SelloutImpactReportDetailFilterDTO");

var SelloutImpactReportDetailFilterDTOConverter_1 = require("./SelloutImpactReportDetailFilterDTOConverter");

var SelloutImpactReportFilterDTOConverter_1 = require("./SelloutImpactReportFilterDTOConverter");
/**
 * @author Jaroslav Sevcik
 */


var SelloutImpactReportDetailFilterDTOConverterImpl =
/*#__PURE__*/
function (_SelloutImpactReportD) {
  _inherits(SelloutImpactReportDetailFilterDTOConverterImpl, _SelloutImpactReportD);

  function SelloutImpactReportDetailFilterDTOConverterImpl(selloutImpactReportFilterDTOConverter) {
    var _this;

    _classCallCheck(this, SelloutImpactReportDetailFilterDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutImpactReportDetailFilterDTOConverterImpl).call(this));
    _this.selloutImpactReportFilterDTOConverter = selloutImpactReportFilterDTOConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SelloutImpactReportDetailFilterDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new SelloutImpactReportDetailFilterDTO_1.SelloutImpactReportDetailFilterDTO(this.selloutImpactReportFilterDTOConverter.toObject(source.filter, conversions), conversions.asObjectList(source, 'releaseIds', function (v) {
        return index_1.Utils.asString(v);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return {
        filter: this.selloutImpactReportFilterDTOConverter.toDocument(source.filter, conversions),
        releaseIds: conversions.asObjectArray(source, 'releaseIds', function (v) {
          return v;
        })
      };
    }
  }]);

  return SelloutImpactReportDetailFilterDTOConverterImpl;
}(SelloutImpactReportDetailFilterDTOConverter_1.SelloutImpactReportDetailFilterDTOConverter);

SelloutImpactReportDetailFilterDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [SelloutImpactReportFilterDTOConverter_1.SelloutImpactReportFilterDTOConverter])], SelloutImpactReportDetailFilterDTOConverterImpl);
exports.SelloutImpactReportDetailFilterDTOConverterImpl = SelloutImpactReportDetailFilterDTOConverterImpl;